import { ApiType } from "@gymflow/common";
import { FacilityCategoryDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { facilityQueryKeys } from "./facilityQueryKeys";

export function useFacilityCategories(
  {
    api,
  }: {
    api: ApiType;
  },
  queryOpts?: Omit<UseQueryOptions<FacilityCategoryDTO[]>, "queryKey">,
) {
  return useQuery({
    queryKey: facilityQueryKeys.categories(),
    queryFn: async () => {
      const result = await api.facilityApi.fetchCategories();
      return result.data;
    },
    ...queryOpts,
  });
}
